import { useCart, useProductsQuery } from "@trydig/centra/client";
import { Translate } from "@/components/Translate";
import { Skeleton } from "@/components/ui/Skeleton";
import type { KaosProduct } from "@/lib/centra";
import {
	UpsellProduct,
	UpsellProductSkeleton,
} from "./components/UpsellProduct";
import styles from "./UpsellProducts.module.css";

export const UpsellProducts = () => {
	const {
		data: cartItems,
		isLoading: isCartLoading,
		error: cartError,
	} = useCart();
	const {
		data: cartItemsWithRelatedProducts,
		isLoading: isRelatedProductsLoading,
		error: relatedError,
	} = useProductsQuery({
		products: cartItems?.items
			?.map((item) => item.product?.product)
			.filter(Boolean),
		relatedProducts: true,
	});

	if (isCartLoading || isRelatedProductsLoading) {
		return <UpsellProductsSkeleton />;
	}

	if (cartError || relatedError || !cartItems?.items?.length) {
		return null;
	}

	const allAddonProducts = (cartItemsWithRelatedProducts ?? []).flatMap(
		(product) => {
			return (product.relatedProducts ?? []).filter(
				(relatedProduct) =>
					relatedProduct.relation === "Addons" &&
					!cartItems?.items?.some(
						(item) =>
							item.product?.uri === (relatedProduct as { uri?: string })?.uri,
					),
			);
		},
	) as KaosProduct[];

	const uniqueAddonProducts = Array.from(
		new Map(allAddonProducts.map((item) => [item.uri, item])).values(),
	);

	if (!uniqueAddonProducts?.length) return null;

	return (
		<section className={styles.root}>
			<span className={styles.header}>
				<Translate>You might also need</Translate>
			</span>
			<div className={styles.products}>
				{uniqueAddonProducts.map((item, i) => (
					<UpsellProduct key={i} item={item} />
				))}
			</div>
		</section>
	);
};

export const UpsellProductsSkeleton = ({ size = 6 }: { size?: number }) => {
	return (
		<section className={styles.root}>
			<Skeleton fitContent>
				<span className={styles.header}>Lorem, ipsum dolor.</span>
			</Skeleton>
			<div className={styles.products}>
				{Array.from({ length: size }).map((_, i) => (
					<UpsellProductSkeleton key={i} />
				))}
			</div>
		</section>
	);
};
